module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand-question-answer"
  }, [_c('ul', _vm._l((_vm.datas), function(data, index) {
    return _c('li', {
      key: index,
      staticClass: "qa-list wui-border-1px wui-border-b",
      on: {
        "click": function($event) {
          return _vm.showAnswer(index)
        }
      }
    }, [_c('div', {
      staticClass: "list-question brand-padding-15px"
    }, [_c('span', {
      staticClass: "list-question-content"
    }, [_vm._v(_vm._s(data.question))]), _vm._v(" "), _c('span', {
      staticClass: "triangle"
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.currentIndex === index),
        expression: "currentIndex === index"
      }],
      staticClass: "list-answer brand-padding-15px"
    }, [_c('span', {
      staticClass: "list-answer-a"
    }, [_vm._v("答")]), _vm._v(" "), _c('div', {
      staticClass: "list-answer-content",
      attrs: {
        "id": ""
      }
    }, _vm._l((data.answer), function(answer) {
      return _c('p', [_vm._v(_vm._s(answer.answerQues || ' '))])
    }), 0)])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14582d3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/utils/components/question-answer.vue
// module id = 246
// module chunks = 93